import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { ITransferForm } from "@app/dashboard/types/innerLayout/bills/transfer-modal"
import { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  allow403?: boolean;
};

export const verifyOTP = (payload: ITransferForm) => {
  const {
    receiver_merchant_id,
    amount,
    save_beneficiary,
    otp
  } = payload;

  const params = {
    receiver_merchant_id,
    amount,
    otp,
    ...(save_beneficiary ? {
      save_beneficiary,
    } : {}),
  };

  return axiosPrivate.post('/bills/api/v1/distributor/transfer_verify_otp/', params, { allow403: true } as CustomAxiosRequestConfig)
}